import { type FarmModule } from "@/shared/farm-modules/farmModules.constants";

import { type MenuItemType } from "./menuItems";

type MenuItemFilter = (menuItem: MenuItemType) => boolean;

/**
 * Reports hold Portál farmáře only, which is Czech-specific — user reports
 * live in the parcel list since DEV-1391.
 */
const inCountry =
  (countryCode?: string): MenuItemFilter =>
  (menuItem) =>
    menuItem.id !== "reports" || countryCode === "CZ";

const inEnabledModule =
  (isEnabled: (module: FarmModule) => boolean): MenuItemFilter =>
  (menuItem) =>
    !menuItem.moduleKey || isEnabled(menuItem.moduleKey);

const inDropdown: MenuItemFilter = (menuItem) => !!menuItem.dropdown;

export { inCountry, inDropdown, inEnabledModule };
export type { MenuItemFilter };
